exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "th[data-v-385cb8de]:hover{cursor:pointer}", "", {"version":3,"sources":["/home/circleci/phdva/ui/src/views/admin/report/HitRateReport.vue"],"names":[],"mappings":"AACA,0BACE,cAAgB,CACjB","file":"HitRateReport.vue","sourcesContent":["\nth[data-v-385cb8de]:hover {\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-385cb8de","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/admin/report/HitRateReport.vue
// module id = 2248
// module chunks = 0